import React, { useEffect, useState } from 'react';
import { cn } from '../../lib/cn';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  name?: string;
  hue?: string | undefined;
  size?: number;
  src?: string | undefined;
  /** Shown when there is no `src` (or it fails to load); derived from `name` when omitted. */
  initials?: string | undefined;
}

export function Avatar({ name, hue, size = 36, src, initials: initialsProp, className, ...props }: AvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | undefined>();
  useEffect(() => {
    setFailedSrc(undefined);
  }, [src]);

  const initials =
    initialsProp?.trim() ||
    (name ? name.split(' ').map((part) => part[0]).join('').slice(0, 2) : '?');

  if (src && failedSrc !== src) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => {
          setFailedSrc(src);
        }}
        className={cn('shrink-0 rounded-full object-cover', className)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div {...props} className={cn('flex shrink-0 items-center justify-center rounded-full font-[var(--font-display)] font-semibold text-white', className)} style={{ width: size, height: size, background: hue ?? 'var(--ink-0)', fontSize: size * 0.4 }}>
      {initials}
    </div>
  );
}
